import { createReducer, on } from "@ngrx/store";
import { ProductsActions } from "./products.actions";
import { Products } from "../../models/products.models";

export interface ProductsState {
    products: Products | undefined
}

export const initialState: Readonly<ProductsState> = {
    products:undefined
};

export const ProductsReducers = createReducer(
    initialState,
    on(ProductsActions.addProducts, (state, { products }) => {
        return {
            ...state, 
            products:products
        }
    }),
)